module.exports = boss;


//////////////////
// WEBPACK FOOTER
// external "boss"
// module id = zrhE
// module chunks = 1